export default __webpack_public_path__ + "static/media/icon-circle-notes-header.d1283c1f.svg";